/**
 * Small svg action button for adding child nodes to a selected node.
 */
import React from 'react';

type AddButtonProps = {
    x: number;
    y: number;
    onClick: () => void;
};

export default function AddButton({ x, y, onClick }: AddButtonProps) {
    return (
        <g
            className='svg-button'
            transform={`translate(${x}, 0)`}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
        >
            <circle cx={0} cy={y} r={10} fill='#444' />
            <text
                className='svg-button-text'
                x={0}
                y={y - 1.5}
                fill='#fff'
                fontSize={20}
                fontWeight={300}
                textAnchor='middle'
                dominantBaseline='central'
                style={{ fontFamily: 'var(--font-monospace)' }}
            >
                +
            </text>
        </g>
    );
}
